<paper-workspace-nav
  class="nav"
  placement="page"
  ariaLabel="Visitors"
  i18n-ariaLabel="@@visitors-nav-label"
>
  <ng-container slot="start">
    <!-- Below 640px the rail is a drawer, opened from here. -->
    <paper-button
      class="nav__menu"
      variant="ghost"
      tone="neutral"
      shape="circle"
      size="sm"
      icon="menu"
      ariaLabel="Areas"
      i18n-ariaLabel="@@visitors-areas-label"
      data-testid="visitors.shell.nav.menu.open"
      [attr.aria-expanded]="drawerOpen()"
      (click)="drawerOpen.set(!drawerOpen())"
    />
    <paper-workspace-mark
      [mark]="mark()"
      [logo]="logo()"
      [organisation]="organisation()"
      (activated)="goHome()"
    />
  </ng-container>

  <!-- Search opens the command palette (⌘K): areas, Create's actions and
       people in the address book, until a power search exists. -->
  <paper-search-pill
    slot="centre"
    class="nav__search"
    variant="frost"
    placeholder="Search concierge"
    i18n-placeholder="@@visitors-search-placeholder"
    data-testid="visitors.shell.nav.search.open"
    (clicked)="actions.open()"
  />

  <ng-container slot="end">
    <!-- One Create, app-wide: Add visit, Walk-in and Add contact in its menu. Below 640px
         it folds to its icon. -->
    <span #createTrigger class="nav__create">
      <paper-button
        class="nav__action nav__action--wide"
        variant="solid"
        tone="neutral"
        shape="pill"
        size="sm"
        icon="plus"
        data-testid="visitors.shell.nav.create.open"
        [attr.aria-haspopup]="'menu'"
        [attr.aria-expanded]="createOpen()"
        (click)="toggleCreate(createTrigger)"
        i18n="@@visitors-create"
        >Create</paper-button
      >
      <paper-button
        class="nav__action nav__action--narrow"
        variant="solid"
        tone="neutral"
        shape="circle"
        size="sm"
        icon="plus"
        ariaLabel="Create"
        i18n-ariaLabel="@@visitors-create"
        [attr.aria-haspopup]="'menu'"
        [attr.aria-expanded]="createOpen()"
        (click)="toggleCreate(createTrigger)"
      />
    </span>
    <paper-menu
      #createMenu
      position="below"
      align="end"
      data-testid="visitors.shell.nav.create.menu"
      (closed)="createOpen.set(false)"
    >
      @for (action of createActions; track action.key) {
        <paper-menu-item
          [icon]="action.icon"
          [data-testid]="'visitors.shell.nav.create.' + action.key"
          (selected)="create(action.route)"
          >{{ action.label }}</paper-menu-item
        >
      }
    </paper-menu>
    <!-- Single pick: one location or all of them. Every page follows it. -->
    <paper-location-scope [showGroups]="false" [showDivisions]="false" />
    <span class="nav__notifications">
      <paper-notification-trigger
        intent="neutral"
        [badge]="0"
        data-testid="visitors.shell.nav.notifications.open"
        (clicked)="notificationsOpen.set(!notificationsOpen())"
      />
      <paper-notification-panel
        [notifications]="[]"
        [open]="notificationsOpen()"
        (closed)="notificationsOpen.set(false)"
      />
    </span>
    <!-- The operator: the profile panel carries the theme (Appearance). -->
    <paper-profile-panel
      [identity]="identity()"
      [actions]="profileActions"
      (action)="onProfileAction($event)"
    />
  </ng-container>
</paper-workspace-nav>

<div class="shell">
  <!-- Reception's areas, one group, on every page. Folds to icons
       (remembered under stateKey); a drawer below 640px. -->
  <paper-workspace-rail
    class="shell__rail"
    label="Reception"
    i18n-label="@@visitors-rail-label"
    data-testid="visitors.shell.rail"
    stateKey="reception"
    [sections]="railSections"
    [activeKey]="activeKey()"
    [(drawerOpen)]="drawerOpen"
  />

  <paper-panel-layout class="shell__layout">
    <main class="shell__canvas" paperPanelCanvas>
      <router-outlet />
    </main>
    @for (kind of panels.all; track kind.kind; let i = $index) {
      <paper-panel-host
        layout="push"
        contentMode="fill"
        [requests]="kind"
        [order]="i + 1"
        [heading]="kind.request()?.target?.heading() ?? null"
        [label]="kind.request()?.target?.label?.() ?? null"
        [width]="kind.request()?.target?.width ?? null"
      >
        <ng-template [paperPanelContent]="kind" let-request>
          <ng-template [cdkPortalOutlet]="request.target.portal" />
        </ng-template>
      </paper-panel-host>
    }
  </paper-panel-layout>
</div>

<paper-command-palette />
<paper-toast-stack />
